import { SkeletonLoader } from "@pepperstone/pepper-ui-kit";

export const PaginationSkeletonLoader = () => {
  return (
    <div className="content-start gap-2 md:grid md:grid-cols-3 md:align-middle">
      <div className="content-center text-sm text-border-primary-strong sm:pb-2">
        <SkeletonLoader variant="rectangular" height={6} />
      </div>
      <div className="flex w-full justify-normal md:justify-center">
        <SkeletonLoader variant="rectangular" height={6} width={24} />
      </div>
    </div>
  );
};
